import React, { useEffect, useState } from 'react'
 
import { useNavigate } from "react-router-dom";

 
import { MegaMenu } from 'primereact/megamenu'; 
import HrAllRequest from './Hr-allRequest';
import HrApprovedRequest from './Hr-ApprovedRequest';
import HrRejectedRequest from './Hr-RejectedRequest';
import HrTeamRequestApproval from './Hr-TeamRequestApproval';
 
 
  
const HrHead = () => {
const [currentTab, setCurrentTab] = useState(1);
  const navigate = useNavigate();  


  useEffect(() => {
    // setViewEmpList(true);
    // setViewEmpAttendance(false);
  }, []);
// }
 

  

  
  

  const menu1 = [
    {
      label: 'All Request',
      icon: 'pi pi-fw pi-file',
      command: () => setCurrentTab(1),
    },
    {
      label: 'Request Approval',
      icon: 'pi pi-pencil',
      command: () => setCurrentTab(2),

    },
    {
      label: 'Approved Request',
      icon: 'pi pi-check',
      command: () => setCurrentTab(3),

    },
    {
      label: 'Rejected Request',
      icon: 'pi pi-times',
      command: () => setCurrentTab(4),
    },
     
  ];
 
 

// const TeamTravel = () => {  
  return (
    <div className="tabview-demo">
      <div className="card mb-3"> 
        <MegaMenu model={menu1} />
      </div>
      <div className="flex grid">
         

        <div className="grid col-12" >
          {currentTab && currentTab == 1 && (

             <HrAllRequest />
          )}
          {currentTab && currentTab == 2 && (
             <HrTeamRequestApproval /> 
          )}
          {currentTab && currentTab == 3 && (
              <HrApprovedRequest />
          )}
           {currentTab && currentTab == 4 && (
              <HrRejectedRequest />
          )}
        </div>
      </div>
    </div >

  )

          }

 
 export default HrHead;